import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ExportButtonRendererComponent } from '../export-button-renderer';
import { MAT_DIALOG_DATA, MatDialogRef, MatExpansionPanel } from '@angular/material';
import { GridApi, GridOptions } from 'ag-grid-community';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { SpinnerService } from '../services/spinner.service';
import { NotificationService } from '../services/notification.service';
import { ExportPassService } from '../services/export-pass.service';
import { SearchService } from '../services/search.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-download-grid',
  templateUrl: './download-grid.component.html',
  styleUrls: ['./download-grid.component.css']
})
export class DownloadGridComponent implements OnInit {

 @ViewChild("freezePanel") freezePanel: MatExpansionPanel;
  protected appLanguage;
  protected step = 0;
  public screenLabels: Array<string> = [];
  private gridApi: GridApi;
  public defaultColDef: object;
  public columnDefs: any;
  public rowData: any;
  protected exportSearch;
  protected exportDescription;
  protected noDataFound: boolean = false;
  
  constructor(
     @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DashboardComponent>,
    protected spinnerService: SpinnerService,
    protected exportPassService: ExportPassService,
    protected notificationService: NotificationService,
    protected searchService: SearchService,
    protected datePipe: DatePipe
   // protected userService: UserService
  ) { 
    console.log("data",data);
     this.defaultColDef = {
      resizable: true,
    };
  }

  ngOnInit(): void {
    this.setColumnDef();
     //load export grid
     this.exportSmartSearch();

  }

  setColumnDef() {
    this.columnDefs = [
       {
        headerName: "Search Key",
        field: "Key",
        hide: false,
        width: 180,
        sortable: true,
      },
      {
        headerName: "Description",
        field: "Description",
        hide: false,
        width: 250,
        sortable: true,
      },
      {
        headerName: "Time Stamp",
        field: "CreatedDate",
        hide: false,
        sort: 'desc',
        sortable: true,
        cellRenderer: (data) => {
        const formattedDate = this.datePipe.transform(data.value, "MM/dd/yyyy h:mm a");
        return formattedDate ? formattedDate : null;
      },
      },
      {
        headerName: "Status",
        field: "Status",
        hide: false,
        width: 200,
        sortable: true,
        cellRenderer: (data) => {
          if(data.value=='Succeeded') return data.value = 'Ready for Download';
          else if(data.value=='Submitted') return data.value = 'Submitted';
          else if(data.value=='Processing') return data.value = 'Processing';
        }
      },
      {
        headerName: "Action",
        field: "Action",
        cellStyle: { color: "#589bf8" },
        cellRendererFramework: ExportButtonRendererComponent,
       // width: 100,
        cellRendererParams: {
          onClick: this.downloadFile.bind(this),
          onDeleteClick: this.deleteFile.bind(this),
          label: "View Assets"
        },
      },
    ]
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  onFirstDataRendered(params) {
    // setTimeout(() => {
    //   this.spinnerService.setIsLoading(false);
    //   params.api.resetRowHeights();
    // }, 0); 
    params.api.sizeColumnsToFit();
  }

   gridOptions: GridOptions = {
    overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Loading...</span>', // Custom loading message
    overlayNoRowsTemplate: '<span class="ag-overlay-loading-center">No data has been exported</span>'
  };

  onNoClick(): void {
    this.dialogRef.close();
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  onMainHeaderClose() {
    this.freezePanel.open();
  }

  onKeyInput(event) {
    if (this.noDataFound && (!this.data.searchKey && !this.exportDescription)) return this.noDataFound = false;
  }
  onDescriptionInput(event) {
    if (this.noDataFound && (!this.data.searchKey && !this.exportDescription)) return this.noDataFound = false;
  }

  exportSmartSearch() {
     this.exportPassService.checkExportSearch(this.data.searchKey, this.exportDescription, this.data.ScreenName).subscribe({
        next: (res: HttpResponse<any>) => {
           if(res?.body?.length > 0) {
           this.rowData = res.body.filter(e => e.Status !== 'Delete');
           this.gridApi.hideOverlay();
          }
          else {
            this.gridApi.showNoRowsOverlay();
          }
        },
        error: (err) => {
          console.error('Status check failed', err);
        }
      });
  }

   onInitiateExport() {
    this.searchService
      .smartSearchAPI(this.data.searchKey)
      .then(() => {
       // this.toggle.checked = false;
       // this.data = this.searchService.searchRecords;
        let searchData = this.searchService.searchRecords
        if (searchData.length > 0) {
          this.noDataFound = false;
          this.exportPassService.exportSearch(this.data.searchKey, this.exportDescription, this.data.ScreenName)
            .subscribe({
              next: (res: HttpResponse<any>) => {
                this.notificationService.success(res.body.Message);
                //refresh grid
                this.onGridRefresh();
              },
              error: (err) => {
                console.log("Export API failed here", err);
              }
            })
        }
        else {
          this.noDataFound = true;
        }
      })
       .catch((err: HttpErrorResponse) => {
        this.notificationService.failure(err.message);
      });
  }

  downloadFile(e) {
    this.exportPassService.downloadCSVDirect(e.rowData.ExportQueueID, e.rowData.Description);
   // this.exportPassService.downloadFile(e.rowData.ExportQueueID);
    
  }

  deleteFile(e) {
    console.log("event", e);
    this.exportPassService.deleteExportedFile(e.rowData.ExportQueueID).subscribe({
      next: (res: HttpResponse<any>) => {
        console.log("response", res);
        this.notificationService.success(res.body.Message);
        //refresh grid
        this.onGridRefresh();
      },
      error: (err) => {
        console.log("delete export failed here", err);
      }
    })
  }

  onGridRefresh() {
    this.gridApi.showLoadingOverlay(); // Show loading overlay
    console.log("grid refreshed");
    this.exportSmartSearch();
  }

}
